export default __webpack_public_path__ + "static/media/Sage's Harness of the Soaring Heart.2aabe0d8.jpg";